import { GET_ALL_INVITATION_LIST } from "./actions";

const initialState = {
    invitationList: {
        docs: [],
        totalDocs: 0,
        limit: 10,
        page: 1,
        totalPages: 0,
        pagingCounter: 0,
        hasPrevPage: false,
        hasNextPage: false,
        prevPage: null,
        nextPage: null,
    },
    loading: true,
};

const invitationCodeReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_ALL_INVITATION_LIST:
            return {
                ...state,
                invitationList: payload,
                loading: false,
            };
        default:
            return state;
    }
};
export default invitationCodeReducer;
